import styled from "styled-components"

export const Container = styled.div`
    width: 100%;
`

export const Wrapper = styled.table`
    width: 100%;
`

export const Header = styled.th`
    width: ${props => props.width}%;
    text-align: ${props => props.align};
`

export const Row = styled.tr`
    width: 100%;
`

export const Cell = styled.td`
    text-align: ${props => props.align};
`